<div class="modal-overlay">
  <div class="modal-container">
    <!-- Header -->
    <div class="modal-header">
      <div class="header-content">
        <div class="icon-wrapper">
          <fa-icon [icon]="faFileContract"></fa-icon>
        </div>
        <div>
          <h2 class="modal-title">Editar condiciones</h2>
          <p class="modal-subtitle">
            {{ relationshipType }}
            @if (default.distribution_modality) {
              &middot; {{ default.distribution_modality }}
            }
          </p>
        </div>
      </div>
      <button class="btn-close" (click)="onClose()">
        <fa-icon [icon]="faXmark"></fa-icon>
      </button>
    </div>

    <!-- Content -->
    <div class="modal-body">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="section-divider section-divider--first">
          <fa-icon [icon]="faPercent"></fa-icon>
          <span>Comisiones</span>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="form-group">
            <label
              for="fixed_commission"
              class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1"
            >
              Comisión fija (%)
            </label>
            <div class="relative">
              <input
                type="number"
                id="fixed_commission"
                formControlName="fixed_commission"
                class="app-input pr-10"
                placeholder="Ej: 10"
              />
              <div class="input-icon">
                <fa-icon [icon]="faPercent"></fa-icon>
              </div>
            </div>
            @if (form.get('fixed_commission')?.touched && form.get('fixed_commission')?.invalid) {
              <p class="error-text">Valor entre 0 y 100</p>
            }
          </div>

          <div class="form-group">
            <label
              for="recurring_commission"
              class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1"
            >
              Comisión recurrente (%) *
            </label>
            <div class="relative">
              <input
                type="number"
                id="recurring_commission"
                formControlName="recurring_commission"
                class="app-input pr-10"
                placeholder="Ej: 5"
              />
              <div class="input-icon">
                <fa-icon [icon]="faPercent"></fa-icon>
              </div>
            </div>
            @if (
              form.get('recurring_commission')?.touched && form.get('recurring_commission')?.invalid
            ) {
              <p class="error-text">Valor obligatorio entre 0 y 100</p>
            }
          </div>
        </div>

        <div class="section-divider">
          <fa-icon [icon]="faGaugeHigh"></fa-icon>
          <span>Condiciones generales</span>
        </div>

        <div class="flex flex-wrap gap-4">
          <div class="form-group flex-1 min-w-[220px]">
            <label
              for="operation_limit"
              class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1 min-h-[2.5rem]"
            >
              Límite por Operación
            </label>
            <div class="relative">
              <input
                type="number"
                id="operation_limit"
                formControlName="operation_limit"
                class="app-input pr-10"
                placeholder="Sin límite"
              />
              <div class="input-icon">
                <fa-icon [icon]="faGaugeHigh"></fa-icon>
              </div>
            </div>
            @if (form.get('operation_limit')?.touched && form.get('operation_limit')?.invalid) {
              <p class="error-text">El valor debe ser positivo</p>
            }
          </div>

          <div class="form-group flex-1 min-w-[220px]">
            <label
              for="settlement_periodicity"
              class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1 min-h-[2.5rem]"
            >
              Periodicidad Liquidación
            </label>
            <app-custom-select
              id="settlement_periodicity"
              formControlName="settlement_periodicity"
              [options]="settlementPeriodicityOptions"
              [small]="true"
              [showIcon]="false"
              placeholder="-- Sin definir --"
            ></app-custom-select>
          </div>

          <div class="form-group flex-1 min-w-[220px]">
            <label
              for="min_new_clients_per_year"
              class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1 min-h-[2.5rem]"
            >
              Mín. Nuevos clientes / Año
            </label>
            <div class="relative">
              <input
                type="number"
                id="min_new_clients_per_year"
                formControlName="min_new_clients_per_year"
                class="app-input pr-10"
                placeholder="Ej: 6"
              />
              <div class="input-icon">
                <fa-icon [icon]="faUserPlus"></fa-icon>
              </div>
            </div>
            @if (
              form.get('min_new_clients_per_year')?.touched &&
              form.get('min_new_clients_per_year')?.invalid
            ) {
              <p class="error-text">El valor debe ser positivo</p>
            }
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer mt-6">
          <p class="required-legend">* Campo obligatorio</p>
          <button type="button" class="btn-cancel" (click)="onClose()">Cancelar</button>
          <button type="submit" class="btn-submit" [disabled]="isLoading || form.invalid">
            @if (isLoading) {
              <div class="spinner"></div>
              <span>Guardando...</span>
            } @else {
              <fa-icon [icon]="faSave" class="mr-2"></fa-icon>
              <span>Guardar Cambios</span>
            }
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
